// @wc-ignore-file
// (Query keys are data, not copy — a translated key would split the cache.)
import { keepPreviousData, useInfiniteQuery } from "@tanstack/react-query";
import { searchNotionPages } from "../api/notion-context-api";

/** Results per page of the search dialog (the route's maximum). */
const NOTION_SEARCH_PAGE_SIZE = 20;

/**
 * Root of the search dialog's cache: page titles from the project's Notion
 * connection, dropped on sign-out (routes/__root.tsx) like other per-user data.
 */
export const notionSearchQueryRoot = () => ["notion-context-search"] as const;

/**
 * CR-230: the search dialog's results, one page per "More". The previous
 * results stay on screen while the next query loads. Not retried: a failure
 * is a state the dialog explains (not connected, rate limited…), and retrying
 * a 429 would only spend Notion's 3 requests per second for nothing.
 */
export function useNotionPageSearch(containerId: string, query: string, enabled: boolean) {
  return useInfiniteQuery({
    queryKey: [...notionSearchQueryRoot(), containerId, query],
    queryFn: ({ pageParam }) =>
      searchNotionPages({
        containerId,
        query,
        cursor: pageParam ?? undefined,
        limit: NOTION_SEARCH_PAGE_SIZE,
      }),
    initialPageParam: null as string | null,
    getNextPageParam: (lastPage) => lastPage.nextCursor,
    placeholderData: keepPreviousData,
    enabled,
    retry: false,
    staleTime: 30 * 1000,
    gcTime: 60 * 1000,
    refetchOnWindowFocus: false,
  });
}
